export default __webpack_public_path__ + "static/media/790245979952644147.0ff4ce33.png";